import { render, staticRenderFns } from "./generateCert.vue?vue&type=template&id=5099c7a8&scoped=true"
import script from "./generateCert.vue?vue&type=script&lang=js"
export * from "./generateCert.vue?vue&type=script&lang=js"
import style0 from "./generateCert.vue?vue&type=style&index=0&id=5099c7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099c7a8",
  null
  
)

export default component.exports